<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="login-box">
    <h2 class="login-title">欢迎登录</h2>
    <p class="login-des">登录过程中将收到短信，请注意您的手机提示</p>
    <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="login-form">
      <el-form-item label="" prop="phone">
        <el-input
          class="input-box phone-input focus"
          v-model="loginForm.phone"
          autocomplete="off"
          placeholder="请输入手机号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="verificationCode" >
        <el-row class="verificationCode-wrap">
          <el-col :span="14" class="verificationCode-wrap-left">
            <el-input
              class="input-box verificationCode-input"
              v-model="loginForm.verificationCode"
              autocomplete="off"
              placeholder="请输入校验码"
            ></el-input>
          </el-col>
          <el-col :span="10">
            <el-button
              class="getVerificationCode-button"
              :class="{ disabled: isCountingDown }"
              type="primary"
              :disabled="isCountingDown"
              @click="getVerificationCode"
            >
              {{ buttonText }}
            </el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <p class="login-error-tip">{{ errTips }}</p>
      <el-form-item>
        <el-button class="login-button" type="primary" @click="submitForm('loginForm')">登录</el-button>
      </el-form-item>
    </el-form>
    <p class="login-tip">
      登录代表您已阅读并同意
      <a href="https://omgotv.mgtv.com/protocol/sh_privacy" target="_blank" class="items">《个人信息保护政策》</a>
      <a href="https://omgotv.mgtv.com/protocol/sh_server" target="_blank" class="items">《服务协议》</a>
    </p>
    <!-- <LoginCaptcha v-if="needCaptcha" :captchaData="captchaData" @captchaSuccess="captchaSuccess" @closeCaptcha="closeCaptcha"/> -->
  </div>
</template>
<script>
/*eslint-disable*/
import { mapState, mapMutations } from 'vuex'
import { mobileCodeLogin, getMobileCode } from '@/servies/index.js';
import LoginCaptcha from './LoginCaptcha/index.vue'
 
export default {
  data() {
    return {
      needCaptcha: false,
      captchaData: {},
      errTips: '',
      dialogVisible: false,
      loginForm: {
        phone: '',
        verificationCode: ''
      },
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        verificationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      isCountingDown: false,
      count: 60,
      buttonText: '获取验证码'
    }
  },
  components: {
    LoginCaptcha
  },
  mounted() {

  },
  computed: {
    ...mapState(['isLogin', 'userInfo']),
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    onSuccess() {
      alert('验证成功，继续下一步操作！');
    },
    captchaSuccess() {

    },
    closeCaptcha () {
      this.needCaptcha = false
    },
    openDialog() {
      this.dialogVisible = true
    },
    getVerificationCode() {
      if (!this.loginForm.phone) {
        this.$message.error('请先输入手机号')
        return
      }


      getMobileCode({
        operation: 'mobilecodelogin',
          device: 'pc',
          platform: 'pcweb',
          mobile: this.loginForm.phone
      }).then((response) => {
        const { code, msg } = response.data
        if (code == 200) {
          console.log('发送验证码到：' + this.loginForm.phone)
          this.$message.success('验证码已发送')

          this.isCountingDown = true
          this.buttonText = `${this.count}秒后重新获取`
          const interval = setInterval(() => {
            this.count--
            this.buttonText = `${this.count}秒后重新获取`
            if (this.count === 0) {
              clearInterval(interval)
              this.isCountingDown = false
              this.buttonText = '重新获取'
              this.count = 60
            }
          }, 1000)
        } else if (code == 4000000005) {
          // this.needCaptcha = true
          // this.captchaData = {
          //   suid: response.data.data.suId, 
          //   reqId: response.data.data.reqId,    
          //   uuid: this.loginForm.phone, 
          //   did: this.$utils.getSTKUUID()
          // }
        } else {
          this.$message({
            message: msg,
            type: 'error'
          })
          this.$emit('fail')
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          mobileCodeLogin({
            mobile: this.loginForm.phone,
            mobileCode: this.loginForm.verificationCode
          }).then(
            (response) => {
              const { code, data, msg } = response.data
              if (code == 200) {
                const userInfo = data
                this.$utils.setCookie('token', userInfo.token)
                this.$utils.setCookie('uuid', userInfo.uid)
                localStorage.setItem('token', userInfo.token);
                localStorage.setItem('sh-userInfo', JSON.stringify(userInfo));
                // store.commit('setUserInfo', userInfo)
                this.$emit('handleLoginSuccess', userInfo)
              } else {
                this.$message({
                  message: msg,
                  type: 'error'
                })
                this.$emit('fail')
              }
          });
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="less" scoped>
.login-box {
  position: absolute;
  z-index: 2;
  background: #fff url('@/assets/images/sh-login-bg.png') right top no-repeat;
  background-size: 230px 152px;
  left: 50%;
  top: 36%;
  margin-left: -265px;
  width: 530px;
  padding: 0 50px 0 50px;
  height: 447px;
  border-radius: 24px;

  .login-title {
    margin-top: 48px;
    height: 48px;
    line-height: 48px;
    font-size: 30px;
  }
  .login-des {
    margin-bottom: 38px;
    color: var(--gray-500, #a3b2c2);
  }
  .verificationCode-wrap{
    display: flex;
  }
  .verificationCode-wrap-left{
    margin-right: 20px;
  }
  .input-box {
    height: 48px;
    line-height: 48px;
    flex-shrink: 0;
    border-radius: 12px;
    border: 1px solid #c5cfd8;
    background: #fff;
    &.phone-input {
      width: 430px;
    }
    &.verificationCode-input {
      width: 244px;
    }
    &.focus {
      border: 1px solid #04cbcd;
      // box-shadow: 0 0 2px 2px rgba(210, 242, 242, 1), 0 0 0 1px #35c0c6 inset;
    }
  }
  ::v-deep {
    .el-input__inner {
      border: none;
      border-radius: 12px;
    }
    .el-form-item__error {
      color: #ff404f;
      font-size: 14px;
    }
  }
  .getVerificationCode-button {
    width: 166px;
    height: 48px;
    padding: 0;
    line-height: 48px;
    text-align: center;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #c5cfd8;
    color: #181818;
    font-weight: normal;
    &.disabled {
      border: 1px solid #e4ebf1;
      background: #f0f5f9;
      color: var(--gray-500, #a3b2c2);
    }
  }
  .login-tip {
    width: 430px;
    text-align: center;
    color: #a3b2c2;
    font-size: 16px;
    .items {
      color: #474d6b;
    }
  }
  .login-error-tip {
    color: #ff404f;
    margin-top: -20px;
  }
  .login-button {
    display: block;
    margin: 24px 0 5px 0;
    width: 430px;
    height: 48px;
    font-size: 18px;
    text-align: center;
    color: #fff;
    border-radius: 12px;
    border: none;
    background: linear-gradient(90deg, #4ee2a4 0%, #04cbcd 100%), #04cbcd;
  }
}
</style>
